import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const MinimalShell = ({ children }) => (
  <div className="bg-[#080B12] min-h-screen">
    <header className="fixed top-0 left-0 right-0 z-50 py-4 bg-[#080B12]/85 backdrop-blur-xl border-b border-[#C9A24B]/12">
      <div className="max-w-6xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <Link to="/" data-testid="minimal-logo" className="flex items-center">
          <img src="/assets/logos/gme-horizontal-white.webp" alt="Gary Malkin Enterprises" className="h-9 md:h-10 w-auto" />
        </Link>
        <Link to="/" data-testid="minimal-back" className="inline-flex items-center gap-2 text-sm text-cream/60 hover:text-[#E7CC86] transition-colors">
          <ArrowLeft size={16} /> Back to site
        </Link>
      </div>
    </header>
    <main>{children}</main>
  </div>
);
